/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 1/12/2021
 */
import BaseFormElement from "@/core/modules/coach/Resources/Forms/model/FormElements/BaseFormElement";
import {evaluateFormFormula} from "@/utils/helpers.js";

export default class BaseMultiFormElement extends BaseFormElement {

	answerOptions = []
	answerOptionsScoring = []
	showOtherOption: boolean = false
	otherAnswer: string = ""


	constructor(type, title, isRequired) {
		super(type, title, isRequired);
		this.resetElement()
	}

	addAnswerOption(option, scoreFormula){
		this.answerOptions.push(option)
		if(scoreFormula){
			this.answerOptionsScoring.push(scoreFormula)
		}
		return this
	}

	clearOptions(){
		this.answerOptions = []
		this.answerOptionsScoring = []
		return this
	}

	resetElement(){
		super.resetElement()
		this.answerOptions = ["Option 1", "Option 2"]
		this.otherAnswer = null
		this.showOtherOption = false
		this.showScoring = true
		this.enableScoring = true
		this.isAutoScoreAscending = true
		this.recalculateScoring()
	}

	fillOptionsFrom(formElement) {
		console.log("fillOptionsFrom: this.isAutoScoreAscending = " + this.isAutoScoreAscending)

		super.fillOptionsFrom(formElement);
		console.log("fillOptionsFrom 2: this.isAutoScoreAscending = " + this.isAutoScoreAscending)
		this.recalculateScoring()
	}

	computeResultScore(scoreFormula, numberOfAnswers){
		let score
		if(typeof scoreFormula === "number") {
			score = scoreFormula
		} else {
			scoreFormula = scoreFormula.replaceAll("#ans", numberOfAnswers || this.numberOfAnswers())
			score = evaluateFormFormula(scoreFormula) || 0
		}
		return Math.max(0, score)
	}

	numberOfAnswers(){
		return 0
	}

	recalculateScoring(){
		// console.log("recalculateScoring: this.isAutoScoreAscending = " + this.isAutoScoreAscending)
		if(this.isScoringManual){
			return
		}
		// this.isScoringManual = false
		let scoring = []
		let len = this.answerOptions.length

		for(let i = 0; i < len; ++i){
			let score = this.isAutoScoreAscending ? i + 1 : len - i
			scoring.push(score)
		}
		this.answerOptionsScoring = scoring

	}

	// onLoadedFromDb() {
	// 	super.onLoadedFromDb();
	// 	console.log("onLoadedFromDb")
	// 	this.recalculateScoring()
	// }
}
